module.exports = __webpack_public_path__ + "img/logo-branca.5f9aa639.png";